import murmurhash from 'murmurhash'

export default function murmurColor (name, opacityHex) {
  return '#' + (0x1000000 + (murmurhash.v2(name)) * 0xffffff).toString(16).substr(1, 6) + opacityHex
}
